// ProductAddRow — 상품 추가줄. **분류를 먼저 고르고 상품명을 쓴다**(2026-09-23 사용자 지적 — 어느
//   상자에 넣을지 정하고 이름을 적는 순서가 자연스럽다).
//
// 분류는 한 칸에서 고르거나 새로 만든다(2026-09-22). `+ 새 분류 직접 입력`을 고르면
//   **목록은 그대로 둔 채 옆에 쓰는 칸이 하나 더 나온다**(2026-09-23 사용자 요청 — 라디오 목록에서
//   '기타'를 고르면 그 자리에 입력칸이 붙는 것과 같은 모양). 예전에는 목록이 사라지고
//   `목록에서 고르기` 버튼으로 되돌아와야 했다 — 그 버튼은 없앴다.
//   더 예전에는 오른쪽에 `카테고리 추가` 입력칸이 따로 있었다(CategoryAddRow) — 그 줄도 없앴다.
//
// 운영사와 손님 회사의 모양은 같고, 담기는 목록만 다르다:
//   - 운영사(전역 카테고리 있음) : product_categories 목록. `직접 입력`은 전역 카테고리를 새로
//     만드는 것이라 동적 관리 권한이 있을 때만 보인다(fail-closed, 서버도 같은 권한을 요구).
//   - 손님 회사(전역 카테고리 0개): 자기가 이미 쓰던 분류 이름들(myCatNames). 이쪽 `직접 입력`은
//     ticket_types.category 에 글자를 적는 것뿐이라 권한이 필요 없다.
//   다른 회사 분류는 어느 쪽에도 섞이지 않는다.
import React, { useState } from 'react';
import { input, addBtnOnDark, addRow, addRowLabel, addRowHint } from './productStyles';

const NEW_CATEGORY = '__new_category__';
const NO_CATEGORY = '';

// 칸 크기 맞추기 — select 와 input 은 브라우저 기본 높이가 달라서 둘 다 못박아 둔다.
//   분류 칸은 너비도 고정한다(안 그러면 분류 이름 길이에 따라 들쭉날쭉하다).
const FIELD = { boxSizing: 'border-box', height: 34, lineHeight: '18px' };
const nameField = { ...input, ...FIELD, width: 220 };
const catField = { ...input, ...FIELD, width: 180 };
// 새 분류를 쓰는 칸 — 목록 바로 옆에 붙어 한 덩어리로 보이게 살짝 좁다
const newCatField = { ...input, ...FIELD, width: 150 };

export function ProductAddRow({ ctl, canManageCategory }) {
  const {
    saving, freeCategory, categories, myCatNames,
    newName, setNewName, newCategory, setNewCategory, add,
  } = ctl;

  const [typing, setTyping] = useState(false);

  const options = freeCategory ? myCatNames : categories.map((c) => c.name);
  // 손님 회사는 자유 텍스트라 권한이 필요 없다
  const canType = freeCategory || canManageCategory;
  // 운영사인데 고를 카테고리가 하나도 없으면(첫 카테고리) 쓰는 칸만 있으면 된다
  const mustType = options.length === 0 && !freeCategory;
  const showNewBox = typing || mustType;
  // 쓰는 칸이 열려 있는 동안 목록은 `+ 새 분류 직접 입력`에 머문다
  const selectValue = showNewBox ? NEW_CATEGORY : newCategory;

  function onPickCategory(e) {
    const v = e.target.value;
    if (v === NEW_CATEGORY) { setTyping(true); setNewCategory(''); return; }
    setTyping(false);
    setNewCategory(v);
  }

  async function onAdd() {
    const madeCategory = await add();
    // 새 분류로 저장했으면 목록에 생겼으니 그 분류를 고른 상태로 돌아간다
    if (madeCategory) { setTyping(false); setNewCategory(madeCategory); }
    else if (typing && freeCategory && newCategory.trim()) { setTyping(false); }
  }

  return (
    <div style={addRow}>
      <strong style={addRowLabel}>상품 추가</strong>

      {!mustType && (
        <select style={catField} value={selectValue} onChange={onPickCategory} aria-label="분류 고르기">
          {freeCategory && <option value={NO_CATEGORY}>분류 없음</option>}
          {options.map((name) => <option key={name} value={name}>{name}</option>)}
          {canType && <option value={NEW_CATEGORY}>+ 새 분류 직접 입력</option>}
        </select>
      )}

      {showNewBox && (
        <input
          style={newCatField} autoFocus={typing}
          placeholder="새 분류 이름"
          aria-label="새 분류 이름"
          value={newCategory} onChange={(e) => setNewCategory(e.target.value)}
          onKeyDown={(e) => { if (e.key === 'Enter') onAdd(); }}
        />
      )}

      <input style={nameField} placeholder="새 상품명" value={newName}
        onChange={(e) => setNewName(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') onAdd(); }} />

      <button
        style={{ ...addBtnOnDark, ...FIELD, padding: '0 16px' }}
        onClick={onAdd}
        disabled={saving || !newName.trim() || (!freeCategory && !newCategory.trim())}
      >
        추가
      </button>

      <span style={addRowHint}>
        상품은 내 회사 소속으로 저장됩니다
        {freeCategory && !showNewBox ? ' · [분류 없음]으로 두면 미분류에 들어갑니다' : ''}
        {showNewBox ? ' · 없는 이름이면 새 분류가 만들어집니다' : ''}
      </span>
    </div>
  );
}
